import Vue from "vue";
import VueRouter from "vue-router";
import portalRoutes from "./routes/portal";
import featureRoutes from "./routes/feature";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Default",
    component: () => import("../views/home/index"),
    meta: {
      title: "产业学院主入口"
      // keepAlive: true
    }
  }
];

const router = new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  mode: "history",
  base: process.env.BASE_URL,
  routes: [...portalRoutes, ...featureRoutes, ...routes]
});

export default router;
